import Vue from 'vue'
import Router from 'vue-router'
import store from "./store"

export const KEVI_MAINTENANCE_MODE = false;

import Maintenance from './maintenance/maintenance.vue'
import Login from './login/login'
import Dashboard from './dashboard/dashboard'
import Coupons from './coupons/coupons'
import CouponsReport from './coupons/report'
import CustomEvents from './custom-events/custom-events'
import BalanceV2 from './balance-v2/balance'
import CreditStatement from './credit-statement/credit-statement.vue'
import Report from './report/report'
import OrderReport from './order-reports/order-report'
import RetentionReport from './retention-report/retention-report'
import Clients from './clients/clients'
import Leads from './clients/leads'
import ClientV2 from './clients/client-v2.vue'
import Segments from './segments/segments'
import SegmentsForm from './segments/form'
import SegmentsMembersForm from './segments/members-form'
import FormQuestions from './form/questions'
import Forms from './form/forms'
import Automations from './automations/automations'
import AutomationsForm from './automations/form'
import AutomationReport from './automations/report'
import AutomationReachReport from './automations/reach-report'
import Plugins from './settings/plugins/plugins.vue'
import Journey from './settings/journey/journey.vue'
import ClientFields from "./settings/client-fields";
import OrderFields from "./settings/order-fields";
import QuotationFields from "./settings/quotation-fields";
import NotificationSchedule from './settings/notification-schedule.vue'
import UtmAuto from './settings/utm-auto.vue'
import Translations from './settings/translations.vue'
import AgentAuthorization from './agent-authorization/agent-authorization.vue'
import AgentAuthorizations from './settings/agent-authorizations/agent-authorizations.vue'
import Account from './account/account'
import Logout from './login/logout.vue'
import Places from './places/places.vue'
import PlacesUsageReport from './places/usage-report/usage-report'
import PlaceDetails from './places/details.vue'
import PlaceForm from './places/form.vue'
import Inbox from './inbox/inbox'
import EmailGenerator from './places/email-generator'
import PluginForm from './plugins/form'
import Tasks from './tasks/tasks'
import TasksReport from './tasks/report'
import ReportRfm from './report-rfm/report-rfm'
import Products from './settings/products'
import ProductDetail from './settings/product-detail'
import OrderStatus from './settings/order-status'
import QuotationStatus from './settings/quotation-status'
import Support from "./support/support"
import PlanForm from "./plans/form"
import Plans from "./plans/list"
import PlacePlan from "./places/plan"
import Orders from "./orders/orders"
import ImportHistory from "./import-history/history"
import Imports from "./import-history/imports"
import ClientsReport from "./clients-report/clients-report"
import ClientsDeletion from "./clients-deletion/clients-deletion"
import FilesGallery from "./files-gallery/files-gallery"
import DataSets from "./data-sets/data-sets"
import DataSet from "./data-sets/data-set"
import Notifications from "./notifications/notifications"
import EmailReport from "./notifications/email-report"
import ClientsJourney from "./clients/journey/journey"
import ClientsJourneyBoard from "./clients/journey/board"
import Pdv from "./pdv/pdv"
import AccountRewards from "./account/rewards"
import AccountTwoFactor from "./account/two-factor"
import TeamUsers from "./users/team"
import UserWizard from "./users/wizard"
import TeamUserEdit from "./users/member"
import SmartInsertion from "./smart-insertion/smart-insertion"
import Quotations from "./quotations/quotations"
import MergeClients from "./data-sanitanization/merge-clients.vue";
import EmailTest from './settings/email-test.vue'
import Invoices from './invoices/invoices.vue'
import InvoicesClient from './invoices/invoices-client.vue'
import InvoiceDetail from './invoices/invoice-detail.vue'
import Connections from "./settings/connections/connections.vue";
import AddConnection from "./settings/connections/add-connection.vue";
import WebhookEventsPage from "./settings/connections/webhooks/webhook-events.vue";
import BenefitsCenter from './benefits/benefits-center.vue'
Vue.use(Router)

const router = new Router({
    routes: [
        {path: '/maintenance', component: Maintenance, meta: { maintenance: true }},
        {path: '/', component: Login},
        {path: '/dashboard', component: Dashboard},
        {path: '/coupons', component: Coupons},
        {path: '/coupons/report', component: CouponsReport},
        {path: '/balance', component: BalanceV2},
        {path: '/credit-statement', component: CreditStatement},
        {path: '/report', component: Report},
        {path: '/rfm-report', component: ReportRfm},
        {path: '/orders/report', component: OrderReport},
        {path: '/retention-report', component: RetentionReport},
        {path: '/clients', component: Clients},
        {path: '/clients/journey', component: ClientsJourney},
        {path: '/clients/journey/board/:stageId', component: ClientsJourneyBoard},
        {path: '/clients/journey/board/:stageId/:childId', component: ClientsJourneyBoard},
        {path: '/clients/report', component: ClientsReport},
        {path: '/clients/deletion', component: ClientsDeletion},
        {path: '/files-gallery', component: FilesGallery},
        {path: '/data-sets', component: DataSets},
        {path: '/data-sets/new', component: DataSet, props: {type: 'new'}},
        {path: '/data-sets/edit/:id', component: DataSet, props: {type: 'edit'}},
        {path: '/leads', component: Leads},
        {path: '/segments', component: Segments},
        {path: '/segments/add', component: SegmentsForm},
        {path: '/segments/edit/:id', component: SegmentsForm},
        {path: '/segments/:id/members/add', component: SegmentsMembersForm, props: { operation: 'add' }},
        {path: '/segments/:id/members/remove', component: SegmentsMembersForm, props: { operation: 'remove' }},
        {path: '/client/:client_id', component: ClientV2},
        {path: '/automations', component: Automations},
        {path: '/automations/new', component: AutomationsForm, props: {type: 'new'}},
        {path: '/automations/edit/:id', component: AutomationsForm, props: {type: 'edit'}},
        {path: '/automations/report/:id', component: AutomationReport},
        {path: '/automations/reach-report', component: AutomationReachReport},
        {path: '/notifications', component: Notifications},
        {path: '/notifications/email-report', component: EmailReport},
        {path: '/settings/order-status', component: OrderStatus},
        {path: '/settings/quotation-status', component: QuotationStatus},
        {path: '/settings/products', component: Products},
        {path: '/settings/products/:id', component: ProductDetail},
        {path: '/notification-schedule', component: NotificationSchedule},
        {path: '/settings/utm-auto', component: UtmAuto},
        {path: '/settings/translations', component: Translations},
        {path: '/settings/agent-authorizations', component: AgentAuthorizations},
        {path: '/settings/client-fields', component: ClientFields},
        {path: '/settings/order-fields', component: OrderFields},
        {path: '/settings/quotation-fields', component: QuotationFields},
        {path: '/account', component: Account},
        {path: '/account/rewards', component: AccountRewards},
        {path: '/account/2fa', component: AccountTwoFactor},
        {path: '/settings/users', component: TeamUsers},
        {path: '/settings/users/new', component: UserWizard},
        {path: '/settings/users/:id/:section', component: TeamUserEdit, props: true},
        {path: '/authorize-agent', component: AgentAuthorization},
        {path: '/logout', component: Logout},
        {path: '/places', component: Places},
        {path: '/places/usage-report', component: PlacesUsageReport},
        {path: '/places/email-generator', component: EmailGenerator},
        {
            path: '/invoices',
            component: Invoices,
            beforeEnter: (to, from, next) => {
                if (!store.state.user.global_admin) {
                    next('/invoices/my-invoice');
                } else {
                    next();
                }
            }
        },
        {path: '/invoices/my-invoice', component: InvoicesClient},
        {path: '/invoices/:id', component: InvoiceDetail},

        {path: '/place/form', component: PlaceForm},
        {path: '/place/form/:id', component: PlaceForm},
        {path: '/place/:id', component: PlaceDetails},
        {path: '/place/:id/plan', component: PlacePlan},
        {
            path: '/plugin/:plugin',
            component: PluginForm,
            props: (route) => {
                return {
                    plugin: route.params.plugin,
                }
            },
        },
        {path: '/plugin/:pluginPlaceId/import-history', component: ImportHistory},
        {path: '/imports', component: Imports},
        {path: '/forms', component: Forms},
        {path: '/forms/:formsId', component: FormQuestions},
        {path: '/inbox', component: Inbox},
        {path: '/custom-events', component: CustomEvents},
        {path: '/tasks', component: Tasks},
        {path: '/tasks/board', redirect: () => ({ path: '/tasks', query: { view: 'board' } })},
        {path: '/tasks/new', redirect: () => ({ path: '/tasks', query: { create: '1' } })},
        {path: '/tasks/report', component: TasksReport},
        {path: '/support', component: Support},
        {path: '/plans', component: Plans},
        {path: '/plans/add', component: PlanForm},
        {path: '/plans/edit/:id', component: PlanForm},
        {path: '/orders', component: Orders},
        {path: '/settings/plugins', component: Plugins},
        {path: '/settings/journey', component: Journey},
        {path: '/settings/journey/:id', component: Journey},
        {path: '/tasks/boards', redirect: () => ({ path: '/tasks', query: { view: 'board' } })},
        {path: '/tasks/boards/:id', redirect: (to) => ({ path: '/tasks', query: { view: 'board', board_id: to.params.id } })},
        {path: '/pdv', component: Pdv},
        {path: '/smart-insertions', component: SmartInsertion},
        {path: '/quotations', component: Quotations},
        {path: '/merge-clients', component: MergeClients},
        {path: '/settings/email-test', component: EmailTest},
        {path: '/connections', component: Connections},
        {path: '/connections/add', component: AddConnection},
        {path: '/connections/:id/webhooks', component: WebhookEventsPage},
        { path: "/benefits", component: BenefitsCenter },
    ],

    scrollBehavior: function (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
});

router.beforeEach(function (to, from, next) {
    if (KEVI_MAINTENANCE_MODE && !to.meta.maintenance) {
        next({ path: '/maintenance' });
        return;
    }

    var logged = store.state.user.id && store.state.user.token ? true : false;
    store.commit('addPreviousRoute', from)
    if (to.path === '/' && logged) {
       if (to.query.redirect_uri && to.query.client_name) {
            next();
        } else {
            next({
                path: '/dashboard',
            });
        }
    } else {
        if (to.path !== '/' && !logged) {
            next({
                path: '/',
                query: {
                    redirect: to.fullPath,
                },
            });
        } else {
            window.mixpanel?.track("Page visit", {"page": to.path, "fullPath": to.fullPath, "params": to.params});
            try {
                next();
            } catch (e) {
                console.error(e);
            }

        }
    }
});

export default router;
